import React, { useState, useCallback } from "react";
import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";
import { color } from "../StyleData/Config";

// Shows a loading dialog while a print/download function runs, and closes it
// once the download finishes. Usage:
//   const { runPrint, PrintLoader } = usePrintLoader();
//   onClick={() => runPrint(printWorkOrder, id)}
//   ...render {PrintLoader}
export const usePrintLoader = () => {
  const [loading, setLoading] = useState(false);

  const runPrint = useCallback(async (fn, ...args) => {
    setLoading(true);
    try {
      await fn(...args);
    } finally {
      setLoading(false);
    }
  }, []);

  const PrintLoader = (
    <Dialog open={loading} PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            px: 3,
            py: 1,
          }}
        >
          <CircularProgress disableShrink sx={{ color: color.TabLabelcolor }} />
          <Typography sx={{ color: color.masterDialogTitleColor }}>
            Generating PDF...
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );

  return { loading, runPrint, PrintLoader };
};
